import React from "react";
import { Row, Col, Space, Select, DatePicker, Grid } from "antd";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { useBreakpoint } = Grid;

const ReportHeader = ({
  lastMonthStart,
  lastMonthEnd,
  timeFrame,
  handleDateRangeChange,
  setSourceType,
  setCompany,
  sourceNames,
  uniqueCompanies,
}) => {
  const screens = useBreakpoint();

  return (
    <Row>
      <Col span={24}>
        <Space
          direction={screens.xs ? "vertical" : "horizontal"}
          style={{
            marginBottom: 16,
            display: "flex",
            justifyContent: "flex-start",
            flexWrap: "wrap",
            rowGap: screens.xs ? "12px" : "16px", // Used rowGap explicitly
            columnGap: screens.xs ? "12px" : "16px", // Used columnGap explicitly
          }}
        >
          <RangePicker
            defaultValue={[lastMonthStart, lastMonthEnd]}
            value={timeFrame}
            onChange={handleDateRangeChange}
            style={{ width: screens.xs ? "100%" : "auto" }}
          />
          <Select
            defaultValue="all"
            style={{ width: screens.xs ? "100%" : 200 }}
            onChange={setSourceType}
          >
            <Option value="all">All Sources</Option>
            {sourceNames?.map((source) => (
              <Option key={source} value={source}>
                {source}
              </Option>
            ))}
          </Select>
          <Select
            defaultValue="all"
            style={{ width: screens.xs ? "100%" : 200 }}
            onChange={setCompany}
          >
            <Option value="all">All Companies</Option>
            {uniqueCompanies?.map((company) => (
              <Option key={company} value={company}>
                {company?.toUpperCase()}
              </Option>
            ))}
          </Select>
        </Space>
      </Col>
    </Row>
  );
};

export default ReportHeader;
